import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppDomainConfig } from '@domgen/dgx-components';
import { DomainId } from '@domgen/dgx-fe-common';
import {
  DOMAIN_CONFIG,
  domainIdFromDomain,
  ENVIRONMENT,
  RUNTIME_CONFIG
} from '@domgen/dgx-fe-config';
import { environment } from '@domgen/util-environment';
import posthog from 'posthog-js';
import { AppModule } from './app/app.module';

let configXhr = null;
configXhr = new XMLHttpRequest();
configXhr.open('GET', './config.json');
configXhr.send();

// Require due browser caching when clicking the Back / Forward buttons
// If we use the cache we don't retrigger any states or loading, refreshing the page forces this behaviour to prevent the user
// from getting stuck
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    window.location.reload();
  }
});

configXhr.onreadystatechange = function () {
  if (this.status === 200 && this.readyState === 4) {
    const config = JSON.parse(configXhr.responseText);

    loadDomainConfig().then((domainConfig) => {
      if (environment.production) {
        enableProdMode();
      }

      posthog.init(config.POSTHOG_KEY, {
        api_host: config.POSTHOG_HOST,
        person_profiles: 'identified_only',
        defaults: '2025-05-24'
      });

      posthog.init(
        config.brightPosthog.key,
        {
          api_host: config.brightPosthog.host,
          person_profiles: 'identified_only',
          defaults: '2025-05-24'
        },
        'brightClaims'
      );

      platformBrowserDynamic([
        {
          provide: RUNTIME_CONFIG,
          useValue: config
        },
        {
          provide: ENVIRONMENT,
          useValue: environment
        },
        {
          provide: DOMAIN_CONFIG,
          useValue: domainConfig
        }
      ]).bootstrapModule(AppModule);
    });
  }
};

async function loadDomainConfig(): Promise<AppDomainConfig> {
  const domainId: DomainId = domainIdFromDomain(
    DomainId.DomesticAndGeneral,
    {}
  );

  const response = await fetch(`configs/domains/${domainId}.json`);
  return response.json();
}
